module.exports = __webpack_public_path__ + "static/img/banner15.be9dfc48.png";